module.exports = __webpack_public_path__ + "img/sleeve length.5eb203a7.png";